module.exports = __webpack_public_path__ + "static/img/backimg.d957b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_icon_v4.0/backimg.png
// module id = yIO3
// module chunks = 2